import React from "react";

export default function Bookcard({ book }) {
  return (
    <li className="books">
      <div className="title">
        <h3>{book?.volumeInfo?.title}</h3>
      </div>

      <div className="book-img">
        <a href={book?.volumeInfo?.previewLink}>
          <img
            src={book?.volumeInfo?.imageLinks?.thumbnail}
            alt={<i class="fa-thin fa-image"></i>}
          />
        </a>
      </div>
    </li>
  );
}
